export default {
    dimensions: {
        builtIn: {
            USER_ID: 'userId',
        },
        custom: {
            USER_ID: 'dimension1',
        },
    },
};

export const trackEventConstant = {
    COMPONENT: {
        HOME_PAGE: 'HomePage',
        PROFILE_PAGE: 'ProfilePage',
        CHAPTER_PAGE: 'ChapterPage',
        REGION_PAGE: 'RegionPage',
        NETWORK_PAGE: 'NetworkPage',
        GROUP_PAGE: 'GroupPage',
        FORUM_PAGE: 'ForumPage',
        NON_MEMBER_CHAPTER_PAGE: 'NonMemberChapterPage',
        NON_MEMBER_REGION_PAGE: 'NonMemberRegionPage',
        NON_MEMBER_NETWORK_PAGE: 'NonMemberNetworkPage',
        NON_MEMBER_GROUP_PAGE: 'NonMemberGroupPage',
        NON_MEMBER_FORUM_PAGE: 'NonMemberForumPage',
        MEMBER_SEARCH_BOX: 'MemberSearchBox',
        COMMUNITY_SEARCH_BOX: 'CommunitySearchBox',
        EVENT_SEARCH_BOX: 'EventSearchBox',
        MEMBER_DIRECTORY_SEARCH_PAGE: 'MemberDirectorySearch',
        CONTENT_SEARCH_BOX: 'ContentSearchBox',
        COMMUNITY_DIRECTORY_SEARCH_PAGE: 'CommunityDirectorySearch',
        EVENT_DIRECTORY_SEARCH_PAGE: 'EventDirectorySearch',
        MY_CONNECTIONS_PAGE: 'MyConnectionsPage',
        CONTENT_DIRECTORY_SEARCH_PAGE: 'ContentDirectorySearch',
        FEEDBACK_PAGE: 'FeedbackPage',
        ACTIVITY_FEED_CONTENT_PAGE: 'ContentSearchActivityFeed',
        POLICIES_AND_TERMS: 'Policies & Terms',
        BECOME_A_SPEAKER: 'Become a Speaker',
        VIEW_MY_SPEAKER_PROFILE: 'View my Speaker Profile',
        SPEAKER_THANKYOU: 'Speaker Registration Thank you',
        COMMUNITY_PAGES: 'AllCommunityPages',
        MY_LEARNING: 'MyLearning',
        NEWS_FEED: 'News Feed',
        EVENT_LISTING: 'Event Listing',
        SEE_MORE: 'See More',
        EVENTS_QUICK_LINK: 'Events Quick Link',
        SOURCE_QUICK_LINK: 'The Source Quick Link',
        YPO_EVENT_NEW_SEARCH_PAGE_CARD: 'Event Directory Card',
        YPO_EVENT_SEARCH_RECOMMENDATIONS: 'Search Recommendations',
        YPO_EVENT_NEW_SEARCH_PAGE_FILTERS: 'Event Directory Card',
        COMMUNITY_EVENT_WIDGET: 'Community Event Widget',
        HOME_EVENT_WIDGET: 'Home Event Widget',
        YPO_CHAT_WIDGET: 'YpoChatWidget',
        CONDUCT_AND_TERMS: 'Conduct & Terms',
    },
    ACTION: {
        SAVE: 'Save',
        OPEN_MEMBER_PROFILE: 'OpenMemberProfile',
        OPEN_PEOPLE_SEARCH_PAGE: 'OpenPeopleSearchPage',
        OPEN_EVENT_DIRECTORY_PAGE: 'OpenEventDirectoryPage',
        APPLY_FILTER: 'ApplyFilter',
        OPEN_CONTENT_DIRECTORY_PAGE: 'OpenContentDirectoryPage',
        FILTER_MEMBERS_BY_LETTER: 'filterMembersByLetter',
        FILTER_FOLLOWERS_BY_LETTER: 'filterFollowersByLetter',
        FILTER_CONNECTIONS_BY_LETTER: 'filterConnectionsByLetter',
        FILTER_COMMUNITIES_BY_LETTER: 'filterCommunitiesByLetter',
        FILTER_CONTENT_BY_LETTER: 'filterContentByLetter',
        FILTER_EVENTS_BY_LETTER: 'filterEventsByLetter',
        SORT: 'Sort',
        EMAIL: 'Email',
        PHONE: 'Phone',
        CHAT: 'Chat',
        CONNECT: 'Connect',
        FOLLOW: 'Follow',
        OPEN_EVENT: 'OpenEventInCvent',
        MANAGE_CONTACT: 'ManageContact',
        OPEN_CONTENT: 'OpenContent',
        COMMUNITY_REDIRECT: 'CommunityRedirect',
        OPEN_CONNECTIONS: 'OpenConnections',
        OPEN_CONNECTIONS_TAB: 'OpenConnectionsTab',
        MEMBER_CONNECT: 'MemberConnect',
        FEEDBACK_SUBMIT: 'FeedbackSubmit',
        SHARE_FEEDBACK: 'ShareFeedback',
        BACK_CONTENT: 'BackToContentPage',
        OPEN_POLICIES_AND_TERMS: 'Open_',
        BECOME_A_SPEAKER: 'Become a Speaker',
        VIEW_MY_SPEAKER_PROFILE: 'View my Speaker Profile',
        SPEAKER_THANKYOU: 'Speaker Registration Thank you',
        AROUND_ME: 'Around Me Tab',
        SELECT_SEARCH_SUGGESTION: 'SelectSearchSuggestion',
        MY_LEARNING_JOURNEY: 'My Learning Journey',
        OPEN_HERO_NEWS: 'Open Hero News',
        OPEN_ADDITIONAL_NEWS: 'Open Additional News',
        TRANSACTION_HUB_FLAG_COOKIE: 'Continue',
        EVENT_DIRECTORY: 'Event Directory',
        EVENT_DETAIL: 'Event Detail',
        EVENT_FILTERS: 'Event Filters',
        THE_SOURCE: 'The Source',
        ASK_YPO_BUTTON: 'AskYpoConciergeButton',
        CHAT_YPO_BUTTON: 'ChatWithYpoButton',
        EMAIL_YPO_BUTTON: 'EmailYpoButton',
    },
    ENTITY: {
        MY_TOOLS: 'MyTools',
        MEMBER_SEARCH_BOX: 'MemberSearchBox',
        EVENT_SEARCH_BOX: 'EventSearchBox',
        CONTENT_SEARCH_BOX: 'ContentSearchBox',
        EVENTS: 'Events',
        CONTENTS: 'Contents',
        EVENT_TILE: 'EventTile',
        MEMBER_DIRECTORY: 'MemberDirectory',
        ROLODEX: 'Rolodex',
        MEMBER_TILE: 'MemberTile',
        CONTENT_TILE: 'ContentTile',
        ACTIVITY_FEED: 'ActivityFeed',
        MY_CONNECTIONS: 'MyConnections',
        RECOMMENDED_MEMBERS: 'RecommendedMembers',
        FEEDBACK: 'Feedback',
        POLICIES_AND_TERMS: 'Policies & Terms',
        BECOME_A_SPEAKER: 'Become a Speaker',
        VIEW_MY_SPEAKER_PROFILE: 'View my Speaker Profile',
        SPEAKER_THANKYOU: 'Speaker Registration Thank you',
        COMMUNITY_NAVIGATION: 'CommunityNavigation',
        LOCATION_SEARCH: 'LocationSearch',
        ESTABLISHMENT_SEARCH: 'EstablishmentSearch',
        MY_LEARNING_JOURNEY: 'Learning Users',
        HERO_NEWS: 'Hero News',
        ADDITIONAL_NEWS: 'Additional News',
        TRANSACTION_HUB_FLAG: 'TransactionHubAcknowledgment',
        EVENTS_ICON: 'Events Icon',
        CONSIDER_EVENTS: 'Consider These Events',
        QUICK_LINKS: 'Quick Links',
        EVENT_RESULT_CARD_TITLE: 'Title',
        EVENT_RESULT_CARD_IMAGE: 'Image-Button',
        EVENT_RESULT_CARD_THUMBNAIL: 'Thumbnail',
        EVENT_RESULT_CARD_REDIRECT: 'Event Directory Redirect',
        EVENT_RESULT_CARD_ONECLICK: 'One Click',
        EVENT_RESULT_CARD_CHAPTER_TOGGLE: 'Toggle',
        EVENT_RESULT_CARD_FILTER_CATEGORY: 'Category-',
        EVENT_LISTING: 'Event Listing',
        TECHNOLOGY_NETWORK: 'Technology Network',
        ASK_YPO_CONCIERGE: 'AskYpoConcierge',
        CHAT_YPO_CONCIERGE: 'ChatWithYpoConcierge',
        EMAIL_YPO_CONCIERGE: 'EmailYpoConcierge',
    },

    HEADER: 'Header',
    USER_SETTINGS: 'UserSettings',
    OPEN_MENU: 'OpenMenu',
    MY_TOOLS: 'MyTools',
    QUICK_LINKS_MANAGE: 'QuickLinksManage',
    QUICK_LINKS: 'QuickLinks',
    SAVE: 'Save',
    HOME_PAGE: 'HomePage',
};
